var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteMembers = function SvgGradientWhiteMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.807 6.846c0 1.959 1.56 3.546 3.486 3.546 1.926 0 3.487-1.587 3.487-3.546v-.25a.292.292 0 0 0-.29-.296H1.097c-.16 0-.29.132-.29.295v.25ZM4.293 5.755c-1.037 0-1.878-.855-1.878-1.91 0-1.054.84-1.91 1.878-1.91 1.036 0 1.877.856 1.877 1.91 0 1.055-.84 1.91-1.877 1.91Z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.545 6.929c0 2.725 2.172 4.934 4.85 4.934 2.68 0 4.852-2.21 4.852-4.934V6.58c0-.227-.181-.41-.404-.41H7.948a.407.407 0 0 0-.403.41v.349ZM12.396 5.41c-1.443 0-2.612-1.189-2.612-2.656S10.954.097 12.396.097c1.442 0 2.612 1.19 2.612 2.657s-1.17 2.657-2.612 2.657Z",
    fillOpacity: 0.8
  }))));
};

export default SvgGradientWhiteMembers;